import { render, staticRenderFns } from "./ToolbarUser.vue?vue&type=template&id=cf870b5c"
import script from "./ToolbarUser.vue?vue&type=script&lang=js"
export * from "./ToolbarUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf870b5c')) {
      api.createRecord('cf870b5c', component.options)
    } else {
      api.reload('cf870b5c', component.options)
    }
    module.hot.accept("./ToolbarUser.vue?vue&type=template&id=cf870b5c", function () {
      api.rerender('cf870b5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/toolbar/ToolbarUser.vue"
export default component.exports